import Link from 'next/link';
import { Heading } from '@/components/ui/Heading';
import { MenuItem } from '@/core/types/menuApi';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

type FooterListProps = {
  footerItems: MenuItem[];
};

export default function FooterList({ footerItems }: FooterListProps) {
  console.log('footerItems', footerItems[1]);
  return (
    <>
      {/* نسخه موبایل و تبلت: Accordion */}
      <div className="lg:hidden">
        <Accordion type="single" collapsible className="space-y-4">
          {footerItems.map((item) => (
            <AccordionItem key={item.id} value={item.id.toString()}>
              <AccordionTrigger
                className="text-primary-0 py-3 text-xs font-primary-bold 
            data-[state=open]:text-primary-200 
              data-[state=open]:font-primary
              transition-colors"
              >
                {item.title}
              </AccordionTrigger>
              <AccordionContent className="pb-4">
                <ul className="space-y-2 pl-1">
                  {item.children?.map((child) => (
                    <li key={child.id}>
                      <Link
                        href={child.link}
                        className="text-primary-0 text-xs block py-1 transition-colors"
                      >
                        {child.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      {/* نسخه دسکتاپ: Grid ستونی */}
      <div className="hidden lg:grid lg:grid-cols-3 gap-18">
        {footerItems.map((item) => (
          <div key={item.id} className="space-y-4">
            <Heading level={4} className="text-primary-0">
              {item.title}
            </Heading>
            <ul className="space-y-2">
              {item.children?.map((child) => (
                <li key={child.id}>
                  <Link
                    href={child.link}
                    className="text-primary-0/80 hover:text-primary-0 text-sm block transition-colors"
                  >
                    {child.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </>
  );
}